import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SearchBarResults from "../Search/SearchBarResults";
import deletes from "../../assets/delete.svg";
import {
  MdSearch,
  MdAdd,
  MdOutlineContentCopy,
  MdEdit,
  MdDelete,
} from "react-icons/md";
import { FaSort, FaSortUp, FaSortDown, FaRegShareSquare } from "react-icons/fa";

import { MarketplaceCouponListApi } from "../API/Coupons/MarketplaceCouponListApi";
import Pagination from "../Pagination/Pagination";
import MyVerticallyCenteredModal from "../modals/MyVerticallyCenteredModal";
import { toast } from "react-toastify";
import { deleteCouponAPI } from "../API/Coupons/DeleteCoupon";
import { useDebounce } from "../../Utils/hooks/useDebounce";
import { de } from "date-fns/locale";
import { ManageCouponsAPI } from "../API/Coupons/ManageCoupons";
import { OverlayTrigger, Popover } from "react-bootstrap";
import FacebookShare from "../SocialShare/FacebookShare";
import WhatsappShare from "../SocialShare/WhatsappShare";
import { Switch } from "antd";
import { UpdateCouponStatus } from "../API/Coupons/UpdateCouponStatus";
import { DisableVoucherCouponApi } from "../API/Coupons/DisableCoupon";
import { getCouponDeleteModelFlag } from "../../Redux/DeleteModelFlagSlice";
import { useDispatch } from "react-redux";

export const MyCoupons = () => {
  const [loading, setLoading] = useState(false);
  const [couponList, setCouponList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [totalPage, setToatalPage] = useState(null);
  const [pageSize, setPageSize] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [couponStatus, setCouponStatus] = useState({});
  const [deleteCouponId, setDeleteCouponId] = useState(null);

  const searchWithDebounce = useDebounce(handleSearch, 700);

  const [page, setPage] = useState(0);

  const [sortConfig, setSortConfig] = useState({
    coupon_name: 0,
    coupon_created_at: -1,
    coupon_download_count: 0,
    coupon_end_date: 0,
  });

  const dispatch = useDispatch();

  const navigate = useNavigate();


  const handleSort = (column) => {
    let nextOrder = 0;

    if (sortConfig[column] === 0) {
      nextOrder = 1;
    } else if (sortConfig[column] === 1) {
      nextOrder = -1;
    } else {
      nextOrder = 0;
    }
    setSortConfig({
      coupon_name: 0,
      coupon_created_at: 0,
      coupon_download_count: 0,
      coupon_end_date: 0,
      [column]: nextOrder,
    });

    if (nextOrder === 0) {
      getCouponList(page + 1, "coupon_created_at", -1);
    } else {
      getCouponList(page + 1, column, nextOrder);
    }
  };

  const getCouponList = async (
    pageNo = 1,
    sortBy = "coupon_created_at",
    sortOrder = -1,
  ) => {
    try {
      setLoading(true);

      const payload = {
        page: pageNo,
        page_size: 10,
        sort_by: sortBy,
        sort_order: sortOrder,
      };

      const response = await MarketplaceCouponListApi(payload,() => {
            navigate("/");
        });

      if (response?.success) {
        setCouponList(response.data || []);
        setToatalPage(response.total || 0);
        setPageSize(response.page_size || 0);
      } else {
        setCouponList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCouponList(page + 1);
  }, [page]);

  // const handleSort = (column) => {
  //   const order = sortConfig[column] === 1 ? -1 : 1;

  //   setSortConfig({
  //     coupon_name: 0,
  //     coupon_created_at: 0,
  //     coupon_download_count: 0,
  //     coupon_end_date: 0,
  //     [column]: order,
  //   });

  //   getCouponList(page + 1, column, order);
  // };

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    searchWithDebounce(e.target.value);
  };

  async function handleSearch(searchValue) {
    setLoading(true);

    const data = {
      search: searchValue,
    };
    const response = await MarketplaceCouponListApi(data);
    if (response.status) {
      setCouponList(response.data);
      setToatalPage(response.total || 0);
      setPageSize(response.page_size || 0);
      setLoading(false);
    }
  }

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleDeleteCoupon = async (flag) => {
    if (flag === true) {
      setIsDeleting(true);
      const deletePayload = {
        coupon_id: deleteCouponId.couponId,
        marketplace_business_id: deleteCouponId.mbId,
      };
      const response = await deleteCouponAPI(deletePayload,() => {
            navigate("/");
        });

      if (response.status === true) {
        getCouponList(page + 1);
        setIsDeleting(false);
        setModalShow(false);
        setDeleteCouponId({});
        toast.success(response.message, {
          position: "top-center",
          width: "500px",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      if (response.status === false) {
        setModalShow(false);
        setDeleteCouponId({});
        toast.error(response.message, {
          position: "top-center",
          width: "500px",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  const DisableHandler = async (flag) => {
    if (flag === true) {
      const val = {
        checkvoucher_coupon: "coupon",
        product_id: deleteCouponId.couponId,
        marketplace_business_id: deleteCouponId.mbId,
      };
      setLoading(true);
      const DisabledRes = await DisableVoucherCouponApi(val, () => {
        navigate("/");
      });
      if (DisabledRes === false) {
        toast.error(DisabledRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (DisabledRes.success === true) {
          getCouponList(page + 1);
          toast.success(DisabledRes.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          // ManageCouponsAPIHandler();
          setLoading(false);
          setModalShow(false);
        } else if (DisabledRes.status === 429) {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(true);
        } else {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(false);
        }
      }
    }
  };

  const handleCouponStatus = async (checked, couponId) => {
    setCouponStatus((prevState) => ({
      ...prevState,
      [couponId]: checked,
    }));
    const payload = {
      coupon_status: checked ? "published" : "draft",
      coupon_id: couponId,
    };
    setLoading(true);
    const response = await UpdateCouponStatus(payload, () => {
      navigate("/");
    });
    if (response.status) {
      getCouponList(page + 1);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="manage-vou-main pt-3  three-col-heading">
        <p className="page-maintitle pt-1">Coupons</p>
        <div>
          <InputGroup className="search-bar MVouchers">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={handleSearchInput}
              onKeyDown={handleKeypress}
              placeholder="Search Coupon"
            />

            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
          <SearchBarResults SearchValue={searchValue} />
        </div>

        <div className="manage-vou d-flex">
          <Link
            to="/coupons/my-coupons/create-coupon"
            className="toggle-option active m-2"
          >
            <MdAdd /> Create Coupon
          </Link>
        </div>
      </div>
      <div className="flex justify-end items-center gap-1 mb-3">
        <MdOutlineContentCopy fill="#E66100" />
        <p>To copy/clone the coupon</p>
      </div>
      {/* TABLE */}

      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th
                style={{ width: "40%", textAlign: "left" }}
                onClick={() => handleSort("coupon_name")}
              >
                <Button className="btn btn-primary sortIcon">
                  Coupon Name
                  {sortConfig.coupon_name === 0 ? (
                    <FaSort />
                  ) : sortConfig.coupon_name === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>

              <th style={{ width: "20%", textAlign: "center" }}>
                Available Until
              </th>

              <th
                style={{ width: "15%", textAlign: "center" }}
                onClick={() => handleSort("coupon_end_date")}
              >
                {/* <Button className="btn btn-primary sortIcon">
                  Expiry Date
                  {sortConfig.coupon_end_date === 0 ? (
                    <FaSort />
                  ) : sortConfig.coupon_end_date === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button> */}
                Expiry Date
              </th>

              <th
                style={{ width: "10%", textAlign: "center" }}
                onClick={() => handleSort("coupon_download_count")}
              >
                {/* <Button className="btn btn-primary sortIcon">
                  Downloads
                  {sortConfig.coupon_download_count === 0 ? (
                    <FaSort />
                  ) : sortConfig.coupon_download_count === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button> */}
                Downloads
              </th>

              <th style={{ width: "10%", textAlign: "center" }}>Status</th>

              <th
                style={{
                  width: "10%",
                  textAlign: "center",
                  borderTopRightRadius: "15px",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {couponList?.length ? (
              couponList.map((item) => {
                const targetStr = item.coupon_end_date.replace(/-/g, " ");
                const expireDate = new Date(targetStr);
                const currentDate = new Date();
                return (
                  <tr
                    key={item.coupon_id}
                    className={`${item.is_active === 0 ? "disable" : ""}`}
                  >
                    <td
                      // style={{ textAlign: "left" }}
                      className="text-left blue-underline-text"
                      title={item.coupon_name}
                    >
                      <Link
                        to={`/coupons/my-coupons/view-coupon/${item.coupon_id}`}
                      >
                        {item.coupon_name}
                      </Link>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {item.coupon_avail_until_date}
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {item.coupon_end_date}
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {item.coupon_download_count}
                    </td>
                    {/* <td style={{ textAlign: "center" }}>
                      <Switch
                        className="switch-button"
                        checkedChildren="Published"
                        unCheckedChildren="Draft"
                        // disabled={
                        //   item.coupon_status === "published" ? true : false
                        // }
                        checked={
                          couponStatus[item.coupon_id] !== undefined
                            ? couponStatus[item.coupon_id]
                            : item.coupon_status?.toLowerCase() === "published"
                        }
                        onChange={(checked) => {
                          handleCouponStatus(checked, item.coupon_id);
                        }}
                      />
                    </td> */}
                    <td style={{ textAlign: "center" }}>
                      {item.coupon_status?.toLowerCase() === "published"
                        ? "Published"
                        : "Draft"}
                    </td>

                    <td>
                      <div className="action-img action-div">
                        <Link
                          to={`/coupons/my-coupons/edit-coupon/${item.coupon_id}`}
                          onClick={(e) => {
                            if (
                              item.coupon_status?.toLowerCase() ===
                                "published" ||
                              item.is_active === 0
                            ) {
                              e.preventDefault();
                            }
                          }}
                        >
                          <MdEdit
                            size={20}
                            fill={
                              item.coupon_status?.toLowerCase() ===
                                "published" || item.is_active === 0
                                ? "#ccc"
                                : "#E66100"
                            }
                            style={{
                              cursor:
                                item.coupon_status?.toLowerCase() ===
                                  "published" || item.is_active === 0
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            title="Edit"
                          />
                        </Link>

                        <img
                          src={deletes}
                          title="Delete"
                          onClick={(e) => {
                            if (item.is_active === 0) {
                              e.preventDefault();
                              return;
                            }
                            setModalShow(true);
                            setDeleteCouponId({
                              couponId: item.coupon_id,
                              mbId: item.marketplace_business_id,
                            });
                            dispatch(getCouponDeleteModelFlag(item.downloaded));
                          }}
                          style={{
                            cursor:
                              item.is_active === 0 ? "not-allowed" : "pointer",
                          }}
                        ></img>

                        <OverlayTrigger
                          trigger={
                            item.is_active === 0 ||
                            item.coupon_status.toLowerCase() === "draft"
                              ? []
                              : "click"
                          }
                          placement="top"
                          rootClose
                          disabled={
                            item.is_active === 0 ||
                            item.coupon_status.toLowerCase() === "draft"
                              ? []
                              : "click"
                          }
                          placement="top"
                          rootClose
                          // disabled={true}
                          overlay={
                            <Popover
                              id="popover-positioned-top"
                              title="Share to:"
                              className="gap-1 p-1"
                            >
                              <FacebookShare
                                shareUrl={item.product_share_url}
                              />
                              <WhatsappShare
                                shareUrl={item.product_share_url}
                              />
                            </Popover>
                          }
                        >
                          <span>
                            <FaRegShareSquare
                              size={20}
                              fill={
                                item.is_active === 0 ||
                                item.coupon_status.toLowerCase() === "draft"
                                  ? "#ccc"
                                  : "#E66100"
                              }
                              style={{
                                cursor:
                                  item.is_active === 0 ||
                                  item.coupon_status.toLowerCase() === "draft"
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              title="Share"
                            />
                          </span>
                        </OverlayTrigger>
                        <Link
                          to={`/coupons/my-coupons/clone-coupon/${item.coupon_id}`}
                        >
                          <MdOutlineContentCopy
                            size={20}
                            fill="#E66100"
                            style={{ cursor: "pointer" }}
                            title="Clone"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No Coupons Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {couponList?.length > 0 && (
          <Pagination
            totalPageCount={totalPage}
            limit={pageSize}
            setPageNumber={setPage}
          />
        )}
      </div>

      <MyVerticallyCenteredModal
        handleDeletefuc={handleDeleteCoupon}
        show={modalShow}
        handleDisablefuc={DisableHandler}
        onHide={() => setModalShow(false)}
        BtnLoading={isDeleting}
        page={"coupon"}
      />
    </>
  );
};

export default MyCoupons;
